module.exports = __webpack_public_path__ + "ded9c03d8e980fec5aff00ddb98edd26.svg";